import React, { Fragment, useState } from "react";
import moment from "moment-hijri";
import MainCalculatorsList from "./MainCalculators";
import RelatedLinks from "../RelatedLinks";
import { FirstAds, SecondAds, MobileUnderCalAds } from "../../Ads";
import SharedHelmet from "../Helmet";

const TITLE = "Convertir une Date du Grégorien au Hégirien";
const DESCRIPTION =
  "Convertir une Date du Grégorien au Hégirien pour calculer des dates, durees ou ages avec precision. Outil pratique pour vos demarches administratives, votre organisation personnelle et vos besoins du quotidien.";
const KEYWORDS =
  "convertir une date du grégorien au hégirien, calculatrice convertir une date du grégorien au hégirien, calcul en ligne, age, date, temps, calendrier, resultat rapide";
const OG_URL = "https://do-calculate.com/calculator/fr/gregorian_to_hijri";

const GREGORIAN_MONTHS = [
  "Janvier", "Février", "Mars", "Avril", "Mai", "Juin",
  "Juillet", "Août", "Septembre", "Octobre", "Novembre", "Décembre"
];

function ConversionToHijri() {
  const [dateInputs, setDateInputs] = useState({ day: "", month: "", year: "" });
  const [hijriDate, setHijriDate] = useState("");
  const [showError, setShowError] = useState(false);

  const convertToHijri = () => {
    const { day, month, year } = dateInputs;

    if (!day || !month || !year) {
      setShowError(true);
      setHijriDate("");
      return;
    }

    const formattedDate = `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`;
    const isValidDate = moment(formattedDate, "YYYY-MM-DD", true).isValid();

    if (isValidDate && parseInt(year) > 1937) {
      const convertedDate = moment(formattedDate, "YYYY-MM-DD").format("iYYYY-iM-iD");
      setHijriDate(convertedDate);
      setShowError(false);
    } else {
      setHijriDate("");
      setShowError(true);
    }
  };

  return (
    <div style={{ direction: "ltr" }}>
      <SharedHelmet
        TITLE={TITLE}
        DESCRIPTION={DESCRIPTION}
        KEYWORDS={KEYWORDS}
        OG_URL={OG_URL}
      />
      <div className="row">
        <div className="col-12 col-md-8">
          <FirstAds />
        </div>
      </div>
      <div className="row">
        <div className="col-12 col-md-8">
          <br />
          <div
            className="bg-success text-white text-center"
            style={{ height: "50px", display: "flex", alignItems: "center", justifyContent: "center" }}
          >
            <h1 style={{ fontSize: "17px", margin: 0 }}>{TITLE}</h1>
          </div>
          <div className="border border-light ">
            <div className="row ">
              <div className="p-3">
                <p>
                  Cette calculatrice en ligne fournit un moyen facile de convertir des dates du calendrier grégorien au hégirien. Simplement, l'utilisateur choisit le sens de la conversion et entre la date grégorien à convertir. Ensuite, la calculatrice effectue l'opération automatiquement et fournit la date convertie en calendrier hégirien. Le résultat s'affiche de deux façons: d'abord dans un format numérique, et ensuite en fournissant le jour, le mois et l'année de manière détaillée. Cette calculatrice permet aux utilisateurs d'obtenir rapidement et avec précision les dates converties entre le calendrier grégorien et hégirien, ce qui facilite l'organisation des heures et des événements dans la vie quotidienne.
                </p>
                <br />
                Vous pouvez à travers cette calculatrice, saisir la date en format grégorien et elle effectuera la conversion de la date saisie à son équivalent en date hégirien selon le calendrier Um al-Qura.
              </div>
              <br />
            </div>
            <hr />
            <MobileUnderCalAds />
            <div className="row ">
              <div className="col calculatorStyle">
                <div className="p-3 mb-2 bg-success text-white">
                  Convertisseur de Date du Grégorien au Hégirien
                </div>
                <div>
                  <label
                    style={{ fontSize: "18px", fontWeight: "bold", marginBottom: "10px" }}
                  >
                    Entrez la Date Grégorien
                  </label>
                </div>

                <div className="row">
                  <div className="col-md-4">
                    <label  style={{ fontSize: "14px" }}>Jour</label>
                    <select
                      className="form-control"
                      value={dateInputs.day}
                      onChange={(e) => setDateInputs({ ...dateInputs, day: e.target.value })}
                      style={{ fontSize: "16px", padding: "10px" }}
                    >
                      <option value="">Jour</option>
                      {Array.from({ length: 31 }, (_, i) => i + 1).map(day => (
                        <option key={day} value={day}>{day}</option>
                      ))}
                    </select>
                  </div>
                  <div className="col-md-4">
                    <label  style={{ fontSize: "14px" }}>Mois</label>
                    <select
                      className="form-control"
                      value={dateInputs.month}
                      onChange={(e) => setDateInputs({ ...dateInputs, month: e.target.value })}
                      style={{ fontSize: "16px", padding: "10px" }}
                    >
                      <option value="">Mois</option>
                      {GREGORIAN_MONTHS.map((month, index) => (
                        <option key={index} value={index + 1}>
                          {index + 1} - {month}
                        </option>
                      ))}
                    </select>
                  </div>
                  <div className="col-md-4">
                    <label  style={{ fontSize: "14px" }}>Année</label>
                    <select
                      className="form-control"
                      value={dateInputs.year}
                      onChange={(e) => setDateInputs({ ...dateInputs, year: e.target.value })}
                      style={{ fontSize: "16px", padding: "10px" }}
                    >
                      <option value="">Année</option>
                      {Array.from(
                        { length: new Date().getFullYear() - 1936 },
                        (_, i) => new Date().getFullYear() - i
                      ).map(year => (
                        <option key={year} value={year}>{year}</option>
                      ))}
                    </select>
                  </div>
                </div>

                <div className="text-center mt-3">
                  <button className="btn btn-success btn-lg px-5" onClick={convertToHijri}>
                    Convertir
                  </button>
                </div>

                {showError && (
                  <div className="alert alert-danger mt-3">
                    Veuillez entrer une date grégorien valide (après 1937)
                  </div>
                )}

                {hijriDate && (
                  <div className="alert alert-success mt-3">
                    <strong>Date Hégirien Convertie:</strong>
                    <div style={{ fontSize: "24px", color: "#28a745", marginTop: "10px" }}>
                      {hijriDate}
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>
          <br />
          <SecondAds />
          <br />
          <MainCalculatorsList />
          <br />
          <RelatedLinks />
          <br />
          <div className="info-sections-container">
            <div className="info-section">
              <div className="info-section-header"><h3 style={{ fontSize: "16px" }}>Convertir une date grégorienne en hégirien</h3></div>
              <div className="info-section-body">
                <p>Cette calculatrice convertit n’importe quelle date du calendrier grégorien (civil) en date hégirienne (islamique). La conversion est utile pour connaître la date hégirienne correspondant à un événement, pour les fêtes religieuses islamiques, ou pour les documents officiels dans les pays qui utilisent les deux systèmes. L’année 1 de l’hégire correspond au 16 juillet 622 de notre ère.</p>
              </div>
            </div>
            <div className="info-section">
              <div className="info-section-header"><h3 style={{ fontSize: "16px" }}>Pourquoi les dates islamiques changent chaque année</h3></div>
              <div className="info-section-body">
                <p>Comme l’année hégirienne dure 354 jours (au lieu de 365), elle recule d’environ 11 jours chaque année dans le calendrier civil. C’est pourquoi le Ramadan commence à une date différente chaque année : en 2024, il commencé en mars ; quelques années plus tôt, c’était en mai ou juin. Ce cycle complet dure 33 ans environ.</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default ConversionToHijri;
